export const FETCH_MODULE_REQUEST = 'FETCH_MODULE_REQUEST';
export const FETCH_MODULE_SUCCESS = 'FETCH_MODULE_SUCCESS';
export const FETCH_MODULE_FAILURE = 'FETCH_MODULE_FAILURE';

export const UPDATE_MODULE_HISTORY = 'UPDATE_MODULE_HISTORY';
